import { ApiBlueprint, createApiFactory, createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  ALL_RELATION_PAIRS,
  ALL_RELATIONS,
  catalogGraphApiRef,
  DefaultCatalogGraphApi,
} from '@backstage/plugin-catalog-graph';
import {
  MAINTAINED_BY_RELATION,
  MAINTAINER_OF_RELATION,
} from '../maintainers/constant.tsx';

const catalogGraphApiOverride = ApiBlueprint.make({
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: catalogGraphApiRef,
        deps: {},
        factory: () =>
          new DefaultCatalogGraphApi({
            knownRelations: [
              ...ALL_RELATIONS,
              MAINTAINED_BY_RELATION,
              MAINTAINER_OF_RELATION,
            ],
            knownRelationPairs: [
              ...ALL_RELATION_PAIRS,
              [MAINTAINED_BY_RELATION, MAINTAINER_OF_RELATION],
            ],
            defaultRelationTypes: { exclude: [] },
          }),
      }),
    ),
});

export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [catalogGraphApiOverride],
});